import React, { useContext, useEffect, useState } from "react";

import PageContainer from "../../components/PageGeneralContainer/PageGeneralContainer";

import request from "../../utils/request.js";
import t from "../../utils/translation.js";
import LocalizationContext from "../../utils/LocalizationContext.js";

import styles from "./MaterialsTypes.module.css";

import ButtonQ from "../../components/ButtonQ/ButtonQ.js";
import { toast } from "react-toastify";
import MaterialsTypesTable from "./MaterialsTypesTable/MaterialsTypesTable.jsx";
import MaterialsTypesForm from "./MaterialsTypesForm/MaterialsTypesForm.jsx";
import MaterialsTypesDetail from "./MaterialsTypesDetail/MaterialsTypesDetail.jsx";

const initialValue = {
  name: "",
  description: "",
  observations: "",
};

const MaterialsTypes = () => {
  const [materialsType, setMaterialsType] = useState([]);
  const [formData, setFormData] = useState(initialValue);

  const [modal, setModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [materialData, setMaterialData] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  const locale = useContext(LocalizationContext);

  const clearForm = () => {
    setFormData(initialValue);
  };

  const getMaterialsType = async () => {
    setLoading(true);
    try {
      let res = await request().get(`/api/MaterialType/list?includeCount=true&pageSize=${itemsPerPage}&page=${currentPage}`);

      setMaterialsType(res.data.materialTypeListatorList);
      setTotalPages(res.data.totalPages)
    } catch (e) {
      toast.error(e.response?.data?.messagge);
    } finally {
      setLoading(false);
    }
  };

  const handleFormData = (data) => {
    setFormData(data);
  };

  // useEffect(() => {
  //   getMaterialsType();
  // }, []);

  const handleAdd = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
    clearForm();
  };

  const handleDetail = (data) => {
    setMaterialData(data);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setMaterialData({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
  };

  useEffect(() => {
    getMaterialsType();
  }, [itemsPerPage,currentPage]);

  return (
    <PageContainer title={"Materials types"} category={"materials"}>
      <>
        <div className={styles.container}>
          <MaterialsTypesTable
            materials={materialsType}
            getMaterials={getMaterialsType}
            handleData={setFormData}
            handleModal={setModal}
            handleDetail={handleDetail}
            loading={loading}
            onPageChange={handlePageChange} 
            onItemsPerPageChange={handleItemsPerPageChange}
            totalPages={totalPages}
          />
          <div className={styles.detailContainer}>
            <ButtonQ
              caption={t("AddButton") || "Add"}
              onClick={() => handleAdd()}
            />
          </div>
        </div>
   
      </>

      <MaterialsTypesForm
        formData={formData}
        handleFormData={handleFormData}
        handleClose={handleClose}
        open={modal}
        getMaterials={getMaterialsType}
        t={t}
        locale={locale}
      />

      <MaterialsTypesDetail
        open={showDetail}
        handleClose={handleCloseDetail}
        t={t}
        locale={locale}
        materialData={materialData}
      />
    </PageContainer>
  );
};

export default MaterialsTypes;
